// extracted by mini-css-extract-plugin
export default {"Container":"PageTitle_Container__QuBRp","Title":"PageTitle_Title__L3pxw","SubTitle":"PageTitle_SubTitle__gvM8H"};